export default __webpack_public_path__ + "static/logo-ebd8a7f5cdbe1872ab63eed7dfc12f57.png";